import { useLocation, Link } from 'react-router-dom';
import { logout } from '../../utils/auth';
import { NAV, isNavActive } from './nav';

interface SidebarProps {
    open: boolean;
    onNavigate: () => void;
    onToggleRail: () => void;
}

const Sidebar = ({ open, onNavigate, onToggleRail }: SidebarProps) => {
    const { pathname } = useLocation();

    const logOutClick = () => {
        if (window.confirm("Are you sure you want to log out?")) {
            logout();
        }
    };

    return (
        <aside className={`ma-side ${open ? 'open' : ''}`}>
            <div className="ma-brand">
                <img className="ma-logo-img" src="/uomox-logo.png" alt="UOMOX" />
                <span className="ma-tag">Admin</span>
                <span className="ma-logo-mini">U</span>
            </div>

            <nav className="ma-nav">
                {NAV.map(([group, items]) => (
                    <div key={group}>
                        <div className="ma-grp">{group}</div>
                        {items.map(item => (
                            <Link
                                key={item.path}
                                to={item.path}
                                data-tip={item.label}
                                className={`ma-link ${isNavActive(item, pathname) ? 'active' : ''}`}
                                onClick={onNavigate}
                            >
                                <i className={item.icon}></i>
                                <span className="lb">{item.label}</span>
                                {!!item.count && <span className="cnt">{item.count}</span>}
                            </Link>
                        ))}
                    </div>
                ))}
            </nav>

            <div className="ma-sidefoot">
                <button type="button" className="ma-collapse" onClick={onToggleRail} title="Collapse sidebar">
                    <i className="ri-arrow-left-double-line"></i><span className="lb">Collapse</span>
                </button>
                <button type="button" className="ma-link logout" data-tip="Logout" onClick={logOutClick}>
                    <i className="ri-logout-box-r-line"></i><span className="lb">Logout</span>
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
